module.exports = __webpack_public_path__ + "img/provider-email-verified.69184f89.svg";